import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Button,
  Label,
  Form,
  FormFeedback
} from 'reactstrap';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { useFormik } from 'formik';

const ApplyReferralModal = ({ isOpen, toggle, onSubmit, referralItemName, initialValue = "" }) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    applyValue: Yup.string().required(t('ThisFieldIsRequired')),
  });

  const formik = useFormik({
    initialValues: {
      applyValue: initialValue,
    },
    validationSchema,
    onSubmit: (values) => {
      onSubmit(values.applyValue);
      toggle(); // Close modal on submit
    },
    enableReinitialize: true,
  });

  React.useEffect(() => {
    if (isOpen) {
      formik.resetForm({ values: { applyValue: initialValue || "" } });
    }
  }, [isOpen, initialValue]);


  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {t('ApplyTo')} {referralItemName || t('Referral')}
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <div className="mb-3">
            <Label htmlFor="applyValueInput" className="form-label">{t('Enter Coin')}</Label>
            <Input
              type="text"
              id="applyValueInput"
              name="applyValue" 
              placeholder={t('Enter Coin')}
              value={formik.values.applyValue}
              onChange={(e) => {
                        const inputValue = e.target.value;
                        let filteredValue = inputValue.replace(/[^0-9.]/g, '');
                        const parts = filteredValue.split('.');
                        if (parts.length > 2) {
                            filteredValue = parts[0] + '.' + parts.slice(1).join('');
                        }
                        formik.setFieldValue('applyValue', filteredValue);
                    }}
              onBlur={formik.handleBlur}
              invalid={formik.touched.applyValue && !!formik.errors.applyValue}
            />
            {formik.touched.applyValue && formik.errors.applyValue ? (
              <FormFeedback type="invalid">{formik.errors.applyValue}</FormFeedback>
            ) : null}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            {t('Cancel')}
          </Button>
          <Button color="primary" type="submit" disabled={formik.isSubmitting || !formik.isValid}>
            {t('Okay')}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ApplyReferralModal;
